import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-slate-900 via-slate-800 to-blue-950 px-5">
      <div data-testid="payment-cancel-card" className="w-full max-w-md rounded-3xl border border-white/10 bg-white p-8 text-center shadow-2xl">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-amber-50 text-amber-600"><XCircle className="h-8 w-8" /></div>
        <h1 className="mt-4 font-heading text-xl font-bold text-slate-900">Pagamento cancelado</h1>
        <p className="mt-1 text-sm text-slate-500">Você pode escolher um plano quando quiser. Seu teste continua ativo.</p>
        <button data-testid="cancel-back" onClick={() => navigate("/assinar", { replace: true })} className="mt-6 w-full rounded-xl bg-blue-600 py-3.5 text-sm font-bold text-white hover:bg-blue-700">
          Voltar para planos
        </button>
      </div>
    </div>
  );
}
